import {
  enumElementBorderStyle,
  enumElementDrawStates,
  kfontIconNameRegularMedium
} from "../constants";
import { SetCtxFont } from "../utils/SetCtxFont";
import { shadeColor } from "../utils/shadeColor";
import { TruncateText } from "../utils/TruncateText";
import { Globals } from "./Globals";
import { QBasicButton } from "./QBasicButton";

export class QMenuButton extends QBasicButton {
  constructor() {
    super();
    this.fDraPad = false;
    this.fFontString = "12px Arial";
    this.fFontIcon = null;
    this.fFontIconStyle = kfontIconNameRegularMedium;
    this.fIconInset = 30;
    this.fLabelInset = 0;
    this.fIconColor = null;
  }

  SetFontIcon(fontIcon) {
    this.fFontIcon = fontIcon;
  }

  RenderSelectionHighlight(drawBuffer) {}

  InitMenuButton(parent, label, cmdCode, x, y, width, height, fontStyle) {
    this.fWSMgr = parent.GetWSMgrRef();
    this.fUIColors = this.fWSMgr.GetUIColors();
    if (fontStyle) {
      this.fFontString = fontStyle;
    }
    var buttonFill = this.fUIColors.GetButtonFillColor();
    this.SetFontColor(this.fUIColors.GetHeaderTextColor());
    this.fHighlightColor = shadeColor(buttonFill, 5);
    this.fSelectionColor = buttonFill;
    this.SetBorderRadius(4);
    this.SetBorderThickness(0);
    this.SetBorderStyle(enumElementBorderStyle.roundBorder);
    this.SetFillColor(parent.GetFillColor());
    this.SetBorderColor(this.GetFillColor());
    this.SetCmdCode(cmdCode);
    this.SizeElement(width, height);
    this.PositionElement(x, y);
    this.SetLabel(label);
    this.SetLabelLeft();
    this.SetIsSelectable(true);
  }

  SetHasNoFontIconButNeedsIconSet() {
    this.fLabelInset = this.fIconInset;
  }

  DrawPad(drawBuffer, mouseDown, selected, hover, disabled) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var isSelected = this.IsSelected();

    var fillColor = this.fFillColor;
    var strokeStyle = this.fBorderColor ? this.fBorderColor : shadeColor(fillColor, -35);
    var lineWidth = this.fBorderThickness;

    switch (true) {
      case mouseDown:
        fillColor = shadeColor(this.fSelectionColor, -5);
        break;
      case isSelected:
        fillColor = this.fSelectionColor;
        break;
      case hover:
        ctx.globalAlpha = 0.7;
        fillColor = this.fHighlightColor;
        break;
      case disabled:
        fillColor = this.fParentPanelRef.GetFillColor();
        break;
    }

    //if (this.fSelected)
    //{
    //	strokeStyle = gPanelThemeMode.border;
    //	lineWidth = 3;
    //}

    ctx.fillStyle = fillColor;
    ctx.strokeStyle = strokeStyle;

    if (this.fClippedRegion) {
      ctx.fill(this.fClippedRegion);
      if (lineWidth > 0) ctx.stroke(this.fClippedRegion);
    }

    this.DoDrawPad(ctx);

    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    var drawState = this.GetDrawState();
    var txtFillStyle = this.fTxtFillStyle;
    const gPanelThemeMode = Globals._themeMode;

    switch (drawState) {
      case enumElementDrawStates.Disabled:
        txtFillStyle = gPanelThemeMode.text.disabled;
        ctx.globalAlpha = 0.8;
        break;
    }

    ctx.fillStyle = txtFillStyle;

    var fontString = this.fFontString != null ? this.fFontString : "12px Arial";

    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";

    var txt = this.fLabel;
    var labelText = TruncateText(txt, fontString, this.GetWidth());
    var xPos, yPos;

    var txtHIndent = 6;
    ctx.textBaseline = "middle";
    xPos = this.fHorzOffset + txtHIndent;
    yPos = this.fVertOffset + this.fHeight / 2;

    var labelOffset = this.fLabelInset;
    if (this.fFontIcon) {
      this.DrawFontIcon(ctx, xPos, yPos);
      labelOffset = this.fIconInset;
      ctx.fillStyle = txtFillStyle;
    }

    xPos += labelOffset;

    SetCtxFont(ctx, fontString);
    ctx.fillText(labelText, xPos, yPos, this.GetWidth());
    ctx.globalAlpha = 1.0;
    ctx.restore();
  }

  DrawFontIcon(ctx, xPos, yPos) {
    if (this.fIconColor) ctx.fillStyle = this.fIconColor;
    SetCtxFont(ctx, this.fFontIconStyle);
    ctx.fillText(this.fFontIcon, xPos, yPos, this.GetWidth());
  }

  DoDrawPad(ctx) {}
}
